module.exports = __webpack_public_path__ + "img/op55.14353299.png";